<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="data?.markerName"
  [description]="data?.augmentedRealityAsset?.name"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
